// This is a part of the Cadcorp SIS source code. 
// Copyright (c) NEC Software Solutions UK Limited 1991-2026 
import { IAjax } from '../../../../CommonScripts/Abstractions';
import axios from 'axios';
import {extend} from './Utils'

/**
* A wrapper for ajax requests
* @public
*/
export class AjaxWrapper implements IAjax {
    /**
    * @public
    * @property {object} defaultOptions The default options to apply to an ajax request
    */
    readonly defaultOptions: object;

    /**
    * Initialise a new instance of AjaxWrapper
    * @constructor
    * @public
    * @param {object} defaultOptions The default options to apply to an ajax request
    */
    constructor(defaultOptions : object) {
        this.defaultOptions = defaultOptions;
    }
    /**
     * @inheritdoc 
     */
    get(endpoint: string, options: object): Promise<any> {
        options = this.getRequestOptions(options);
        return axios.get(endpoint, options);
    }

    /**
     * @inheritdoc
     */
    post(endpoint: string, data: object, options: object): Promise<any> {
        options = this.getRequestOptions(options);
        var dataStr = this.getDataString(data);
        return axios.post(endpoint, dataStr, options);
    }

    /**
     * @inheritdoc
     */
    upload(endpoint: string, data: object, options: object): Promise<any> {
        options = this.getRequestOptions(options);
        return axios.post(endpoint, data, options);
    }

    /**
     * @inheritdoc
     */
    uploadForm(endpoint: string, data: object): Promise<any> {
        var options = this.defaultOptions;        
        return axios.postForm(endpoint, data, options); // postForm inserts 'Content-Type': 'multipart/form-data'; this is specifically needed for uploading files mixed up with other form data; see https://axios-http.com/docs/multipart
    }

    /**
     * @inheritdoc
     */
    patch(endpoint: string, data: object, options: object): Promise<any> {
        options = this.getRequestOptions(options);
        var dataStr = this.getDataString(data);
        return axios.patch(endpoint, dataStr, options);
    }

    /**
     * @inheritdoc
     */
    delete(endpoint, options: object): Promise<any> {
        options = this.getRequestOptions(options);
        return axios.delete(endpoint, options);
    }

    /**
     * Stringify the supplied data object
     * @private
     * @param {object} [data] The plain object to stringify
     * @return {string} A string representation of the data object or null
     */
    private getDataString(data: object) : string {
        var dataStr = null;
        if (data) {
            dataStr = JSON.stringify(data);
        }
        return dataStr;
    }

    /**
     * Merges the supplied options with the default options
     * @private
     * @param {object} [options] The options to extend
     * @return {object} The merged options
     */
    private getRequestOptions(options: object): object {
        if (!options) {
            options = this.defaultOptions;
        } else {
            var tmp = extend({}, this.defaultOptions);
            options = extend(tmp, options);
        }
        return options;
    }
};

